import documentToReview from '@/components/onboarding/document-to-review/document-to-review.vue';

export default {
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
  components: {
    documentToReview,
  },
};
